import Client from "./_client";

export const getCaseMasterTopics = async () => {
  const result = await new Client({ path: '/casemasterProblem/filter/topics' }).get();
  if (!(result.ok || result.code === 200)) {
    throw new Error(result.message || 'Unable to get case master topics.');
  }
  return result?.data;
};

export const getCaseMasterCases = async (filters = {}) => {
  let url = '/casemasterProblem?';
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${encodeURIComponent(filters[key])}&`;
  });
  const result = await new Client({ path: url }).get();
  if (!(result.ok || result.code === 200)) {
    throw new Error(result.message || 'Unable to get case master cases.');
  }
  return result?.data?.casemasterProblems ?? [];
};

export const createCaseMasterContest = async (data, contestId) => {
  let result;
  if (contestId) {
    result = await new Client({ path: `/casemasterContest/${contestId}`, payload: data }).put();
  } else {
    result = await new Client({ path: '/casemasterContest/', payload: data }).post();
  }
  if (!(result.ok || result.code === 200)) {
    throw new Error(result.message || 'Unable to create case master contest.');
  }
  return result.data;
};

export const getCaseMasterContests = async (filters = {}) => {
  let url = '/casemasterContest/?';
  Object.keys(filters).forEach((key) => {
    // `false` and `0` are meaningful filter values, so only skip blanks.
    const value = filters[key];
    if (value !== undefined && value !== null && value !== '') {
      url += `${key}=${encodeURIComponent(value)}&`;
    }
  });

  const result = await new Client({ path: url }).get();
  if (!(result.ok || result.code === 200)) {
    throw new Error(result.message || 'Unable to get case master contests.');
  }

  const data = result?.data;
  const contests = data?.casemasterContests ?? (Array.isArray(data) ? data : []);

  // Ordering and paging are the server's job — sorting here would only reorder
  // whatever page came back, which silently hides newer rows behind page 1.
  return { casemasterContests: contests, total: data?.total ?? contests.length };
};

export const deleteCaseMasterContest = async (contestId) => {
  const result = await new Client({ path: `/casemasterContest/${contestId}` }).delete();
  if (!(result.ok || result.code === 200)) {
    throw new Error(result.message || 'Unable to delete case master contest.');
  }
  return result;
};
